<div fxLayout="column" style="margin: 3% 0% 0% 2%">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="page-header">
    <button type="button" class="back-btn" mat-mini-fab [routerLink]="'/bots'">
      <mat-icon>
        chevron_left
      </mat-icon>
    </button>
    <label>{{botDetails?.name}}</label>
  </div>
  <mat-card fxLayout="column" style="margin:2% 2% 0% 0%;">
    <div fxLayout="row" class="launch-title" fxLayoutAlign="start center">
      <span class="step-number">Step 01</span>
      <mat-icon style="color: #386AF6;font-size:18px" fxLayoutAlign="center center">
        navigate_next
      </mat-icon> <label class="step-label">Verify Details</label>
    </div>
    <div fxLayout="row" fxFlex="100">
      <div style="border-left:1px dashed #0E0E0E;opacity: 0.1;margin-left: 14px">
      </div>
      <div fxLayout="column" fxFlexOffset="5%" fxFlex="100" fxFlexGap="20px" style="margin:1%">
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Bot Display Name
          </div>

          <div class="field-sub-label">{{botDetails?.name}}</div>
        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Phone No.</div>

          <div>{{phoneNumber}}</div>
        </div>
      </div>
    </div>

    <div fxLayout="row" class="launch-title" fxLayoutAlign="start center">
      <span class="step-number">Step 02</span>
      <mat-icon style="color: #386AF6;font-size:18px" fxLayoutAlign="center center">
        chevron_right
      </mat-icon> <label class="step-label">Bot Details</label>

    </div>
    <div fxLayout="row" fxFlex="100">
      <div style="border-left:1px dashed #0E0E0E;opacity: 0.1; margin-left: 14px">
      </div>
      <div fxLayout="column" fxFlexOffset="5%" fxFlex="100" fxFlexGap="20px" style="margin:1%">
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Type of Bot</div>

          <div class="field-sub-label">{{botDetails?.category}}</div>
        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Bot Description
          </div>

          <div class="field-sub-label">{{botDetails?.description}}</div>
        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
        fxLayoutAlign="start center" fxFlexGap="10%">
        <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Bot labels/tags
        </div>
        <div class="editor-tag input-full-width py-1" >
          <span class="tag-item py-1 mr-2" *ngFor="let tag of tags">
              <span class="pl-2 pr-2">{{tag}}</span>
          </span>
      </div>
        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Bot Display Image
          </div>
          <div style="border: 1px solid #ECECEC;border-radius:10px;padding: 5px;">
            <img class="hidden-sm" [src]="botDetails?.photo" width="75" height="75" />
            <img class="hidden-gt-md" [src]="botDetails?.photo" width="52" height="52" />
          </div>
        </div>
      </div>
    </div>


    <div fxLayout="row" class="launch-title" fxLayoutAlign="start center">
      <span class="step-number">Step 03</span>
      <mat-icon style="color: #386AF6;font-size:18px" fxLayoutAlign="center center">
        chevron_right
      </mat-icon> <label class="step-label">Additional Info</label>

    </div>
    <div fxLayout="row" fxFlex="100">
      <div style="border-left:1px dashed #0E0E0E;opacity: 0.1; margin-left: 14px">
      </div>
      <div fxLayout="column" fxFlexOffset="5%" fxFlex="100" fxFlexGap="20px" style="margin:1%">
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Welcome Text
          </div>
          <div class="field-sub-label">{{botDetails?.welcome_text}}</div>
        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Customer Support
            Phone no.</div>

          <div class="field-sub-label">{{botDetails?.customer_support_phone}}</div>
        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Customer Support
            Email ID</div>

          <div class="field-sub-label">{{botDetails?.customer_support_email}}</div>
        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Customer Support
            Url</div>

          <div class="field-sub-label">{{botDetails?.customer_support_url}}</div>
        </div>

      </div>
    </div>


    <div fxLayout="row" class="launch-title" fxLayoutAlign="start center">
      <span class="step-number">Step 04</span>
      <mat-icon style="color: #386AF6;font-size:18px" fxLayoutAlign="center center">
        chevron_right
      </mat-icon> <label class="step-label">Configure Bot</label>

    </div>
    <div fxLayout="row" fxFlex="100">
      <div style="border-left:1px dashed #0E0E0E;opacity: 0.1; margin-left: 14px">
      </div>
      <div fxLayout="column" fxFlexOffset="5%" fxFlex="100" fxFlexGap="20px" style="margin:1%">
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Configuration
            Parameters</div>

          <div *ngIf="botDetails?.allow_user_media">Camera</div>

        </div>
        <hr>
        <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row"
          fxLayoutAlign="start center" fxFlexGap="10%">
          <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxFlex="20">Webhook URL</div>

          <div class="field-sub-label">{{webHookUrl}}</div>
        </div>
        <hr>
        <div class="field-label responsive-custom-font-bot-config responsive-max-width">Persistent Menu</div>
        <div fxLayout="column" fxFlexGap="10%">
          <div class="responsive-flex-direction-column responsive-align-items-flex-start" fxLayout="row" fxFlex="100"
            fxLayoutAlign="start center" style="margin-bottom: 20px;"
            *ngFor="let button of botDetails?.persistent_menu?.buttons">
            <div class="field-label responsive-custom-font-bot-config responsive-max-width" fxLayout="column"
              fxLayoutGap="15" fxFlex="20">
              <div class="hidden-sm"></div>
              <div class="hidden-sm"></div>
            </div>
            <div fxLayout="column">
              <div class="pt-2">
                <div class="persist-btn responsive-button-name">Button - {{button?.id}}</div>
                <div class="field-sub-label">{{button?.body}}</div>
                <div class="field-sub-label">{{button?.reply}}</div>
              </div>
            </div>
          </div>


        </div>
        <hr>
      </div>
    </div>
    <div class="launch-title" style="flex-direction: column !important;align-items: normal;padding: 1rem;">
      <div style="display: flex;align-items: center;">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 1C13.414 1 17 4.58604 17 9C17 13.414 13.414 17 9 17C4.58604 17 1 13.414 1 9C1 4.58604 4.58604 1 9 1ZM9.3636 1.77276V5.18185H11.9374C11.7839 4.66123 11.6003 4.18156 11.3919 3.7614C10.8299 2.62795 10.116 1.94182 9.36357 1.77263L9.3636 1.77276ZM8.6364 1.77276C7.88393 1.94194 7.17003 2.62808 6.60792 3.7614C6.39955 4.18156 6.21591 4.66123 6.06244 5.18185H8.63623V1.77276H8.6364ZM11.1023 2.03986C11.4573 2.42489 11.7717 2.89693 12.0398 3.43762C12.2976 3.95762 12.5173 4.54531 12.6932 5.182H15.1932C14.2704 3.68723 12.8205 2.55684 11.1023 2.04002V2.03986ZM6.89773 2.03986C5.17948 2.55681 3.72961 3.68706 2.80682 5.18184H5.30682C5.48273 4.54531 5.7024 3.95745 5.96023 3.43745C6.22834 2.89693 6.54286 2.42476 6.89773 2.03969V2.03986ZM15.5851 5.90934H12.8691C13.0483 6.75476 13.1543 7.6745 13.1759 8.63661H16.261C16.2134 7.66372 15.9772 6.74437 15.5849 5.90934H15.5851ZM12.125 5.90934H9.3636V8.63661H12.4488C12.4257 7.66538 12.3118 6.74297 12.1249 5.90934H12.125ZM8.63636 5.90934H5.87497C5.68803 6.74297 5.57414 7.66538 5.55105 8.63661H8.63621V5.90934H8.63636ZM5.13052 5.90934H2.41455C2.02227 6.74437 1.78614 7.66372 1.73844 8.63661H4.8236C4.84529 7.6745 4.95119 6.75463 5.1304 5.90934H5.13052ZM16.261 9.36388H13.1759C13.1544 10.3275 13.0485 11.2456 12.8691 12.0912H15.5851C15.9761 11.2573 16.2136 10.3349 16.2612 9.36388H16.261ZM12.4484 9.36388H9.36321V12.0912H12.1246C12.3116 11.2566 12.4257 10.3361 12.4485 9.36388H12.4484ZM8.63571 9.36388H5.55055C5.57338 10.3361 5.6874 11.2566 5.87447 12.0912H8.63586V9.36388H8.63571ZM4.82305 9.36388H1.73789C1.78545 10.3349 2.02299 11.2573 2.41399 12.0912H5.12997C4.95038 11.2456 4.84448 10.3275 4.82318 9.36388H4.82305ZM15.1925 12.8184H12.6925C12.5166 13.4541 12.2969 14.0371 12.0391 14.5571C11.771 15.0977 11.4566 15.5802 11.1016 15.9661C12.8199 15.4492 14.2697 14.3132 15.1925 12.8184ZM11.937 12.8184H9.36321V16.2334C10.1157 16.0642 10.8296 15.3723 11.3917 14.239C11.6008 13.8175 11.7833 13.3412 11.9372 12.8186L11.937 12.8184ZM8.63571 12.8184H6.06191C6.21576 13.3411 6.39825 13.8173 6.6074 14.2389C7.16948 15.3722 7.88341 16.064 8.63588 16.2332V12.8183L8.63571 12.8184ZM5.30617 12.8184H2.80617C3.72896 14.3132 5.17883 15.4493 6.89708 15.9661C6.54208 15.5801 6.22769 15.0976 5.95958 14.5571C5.70174 14.0371 5.48208 13.4541 5.30617 12.8184Z"
            fill="#0E0E0E" stroke="#0E0E0E" stroke-width="0.3" />
        </svg>
        <label class="step-label" style="padding-left: .5rem;padding-right: .5rem;font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 14px;line-height: 17px;letter-spacing: 0.2px;color: #0E0E0E;">Choose at what level audiences can search for your bot</label>
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle r="7.5" transform="matrix(1 0 0 -1 7.5 7.5)" fill="#999999" />
          <path
            d="M8.57 5.14C9.21272 5.14 9.73375 4.61897 9.73375 3.97625C9.73375 3.33353 9.21272 2.8125 8.57 2.8125C7.92728 2.8125 7.40625 3.33353 7.40625 3.97625C7.40625 4.61897 7.92728 5.14 8.57 5.14Z"
            fill="white" />
          <path
            d="M9.75837 9.86087C9.72623 9.83924 9.69008 9.82425 9.65206 9.81679C9.61404 9.80932 9.57491 9.80952 9.53697 9.81738C9.49903 9.82524 9.46304 9.8406 9.43112 9.86255C9.39919 9.88451 9.37198 9.91262 9.35106 9.94524C9.06981 10.3618 8.72527 10.7318 8.32987 11.0421C8.23386 11.1148 7.87601 11.3912 7.72472 11.333C7.61999 11.301 7.68108 11.0944 7.70145 11.0072L7.85565 10.5504C7.91965 10.3642 9.03394 7.05914 9.15614 6.68093C9.33652 6.12815 9.25796 5.58409 8.43461 5.71501C8.21059 5.73829 5.93837 6.03214 5.89764 6.03505C5.85943 6.03753 5.82209 6.04751 5.78774 6.06443C5.7534 6.08134 5.72272 6.10486 5.69746 6.13363C5.6722 6.1624 5.65285 6.19587 5.64052 6.23212C5.6282 6.26837 5.62313 6.30669 5.62561 6.34489C5.6281 6.3831 5.63808 6.42044 5.655 6.45479C5.67191 6.48914 5.69543 6.51982 5.7242 6.54508C5.75297 6.57034 5.78644 6.58968 5.82269 6.60201C5.85893 6.61434 5.89726 6.6194 5.93546 6.61692C5.93546 6.61692 6.80827 6.50345 6.90428 6.49473C6.95346 6.48992 7.00298 6.49946 7.04686 6.52217C7.09074 6.54489 7.12711 6.57981 7.15158 6.62274C7.2043 6.7857 7.19707 6.96213 7.13121 7.12024C7.05557 7.41118 5.85982 10.7802 5.822 10.9752C5.78143 11.1383 5.79269 11.31 5.85422 11.4664C5.91575 11.6228 6.02448 11.7562 6.1653 11.848C6.42962 12.0241 6.74434 12.1089 7.06139 12.0894C7.36966 12.0857 7.67452 12.0245 7.96038 11.9091C8.68482 11.6181 9.44125 10.8442 9.83984 10.2362C9.87416 10.1744 9.88482 10.1022 9.86983 10.0332C9.85484 9.96411 9.81522 9.90286 9.75837 9.86087Z"
            fill="white" />
        </svg>
        <div class="px-4" style="margin-left: auto;">
            <button (click)="addcountryFormGroup()" class="px-3 py-2" style="font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 15px;
            letter-spacing: 0.002em;
            color: #FFFFFF;
            background: #386AF6;
            border: 1px solid #386AF6;
            border-radius: 8px;font-family: 'Montserrat';
            ">
            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.28689 6H1H6.28689Z" fill="white"/>
                <path d="M5.46335 11C5.46335 11.4548 5.83206 11.8235 6.28689 11.8235C6.74171 11.8235 7.11042 11.4548 7.11042 11H5.46335ZM7.11042 1C7.11042 0.545173 6.74171 0.176463 6.28689 0.176463C5.83206 0.176463 5.46335 0.545173 5.46335 1H7.11042ZM11.5738 6.82354C12.0286 6.82354 12.3973 6.45483 12.3973 6C12.3973 5.54517 12.0286 5.17646 11.5738 5.17646V6.82354ZM1 5.17646C0.545173 5.17646 0.176463 5.54517 0.176463 6C0.176463 6.45483 0.545173 6.82354 1 6.82354V5.17646ZM7.11042 11V6H5.46335V11H7.11042ZM7.11042 6V1H5.46335V6H7.11042ZM6.28689 6.82354H11.5738V5.17646H6.28689V6.82354ZM6.28689 5.17646H1V6.82354H6.28689V5.17646Z" fill="white"/>
            </svg>    
            Add country</button>
            </div>
      </div>
      <div [formGroup]="countryForm">
        <div formArrayName="countries">
          <div *ngFor="let country of countryForm.get('countries')['controls'];let i = index" [formGroupName]="i"
          [ngStyle]="countryForm.get('countries')['controls'].length-1 == i ? {'padding-bottom': '2%'} : {'border-bottom': '1px solid #ECECEC', 'padding-bottom': '2%'}">
            <div class="px-4 pt-3 pb-2"><label style="font-family: 'Montserrat';font-style: normal;font-weight: 500;font-size: 12px;line-height: 15px;letter-spacing: 0.2px;color: #0E0E0E;" 
                *ngIf="form.controls[i].value.country.length == 0">Select the country you want your bot to be visible in </label>
            </div>
            <div class="col-12 px-4 d-flex">
              <app-autocomplete class="w-50" formControlName="country" [dropdownId]="'country'+i" [availableTags]="countryList[i]" [placeholder]="'Select country'" (selected)="selectedData($event, i)" [multiple]="false"></app-autocomplete>
              <button class="px-4 py-1 mx-2 mt-2" (click)="removeOrClearcountry(i)" style="background: #FFFFFF;
              border: 1px solid #386AF6;
              border-radius: 8px;
              color: #386AF6;
              font-family: 'Montserrat';
              font-style: normal;
              font-weight: 500;
              font-size: 12px;height: 32px;
              letter-spacing: 0.002em;padding-top: 0.45rem!important;padding-bottom: 0.45rem!important;" *ngIf="i!= 0">Remove</button>
            </div>
            <div class="col-12 w-50 pl-4" *ngIf="form.controls[i].value.country.length > 0">
              <div class="pt-3 pb-2">
                <label style="font-family: 'Montserrat';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 15px;
                        letter-spacing: 0.2px;
                        color: #0E0E0E;
                        " *ngIf="form.controls[i].value.states.length == 0">Select state, if you want your bot to be searchable only in
                  <b>particular states</b></label>
                </div>
                <app-autocomplete class="w-100" formControlName="states" [dropdownId]="'state'+i" [availableTags]="stateList[i]" [placeholder]="'Select States'" (selected)="onStateItemSelect($event, i)" [multiple]="true"></app-autocomplete>
            </div>
            <div class="col-12 w-50 pl-4" *ngIf="form.controls[i].value.states.length > 0">
              <div class="pt-3 pb-2">
                <label style="font-family: 'Montserrat';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 15px;
                        letter-spacing: 0.2px;
                        color: #0E0E0E;
                        " *ngIf="form.controls[i].value.city.length == 0">Select city, if you want your bot to be searchable only in
                  <b>particular cities</b></label>
                </div>
                <app-autocomplete class="w-100" formControlName="city" [dropdownId]="'city'+i" [availableTags]="cityList[i]" [placeholder]="'Select city'" (selected)="onCityItemSelect($event, i)" [multiple]="true"></app-autocomplete>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" style="width:100%">
      <button type="button" class="verify-btn responsive-max-width" fxLayoutAlign="center center" fxFlex="25" style="padding:10px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';
          font-style: normal;font-size: 14px; " (click)="openLaunchBotpopup()" [routerLink]="'/bots'">Launch Bot
        <mat-icon>
          chevron_right
        </mat-icon>
      </button>
    </div>
  </mat-card>
</div>
